import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginModule),
    title: 'Login | Ontario Security License'
  },
  {
    path: 'checkout-recovery',
    loadChildren: () => import('./pages/checkout-recovery/checkout-recovery.module').then((m) => m.CheckoutRecoveryModule),
    title: 'Resume checkout | Ontario Security License'
  },
  {
    path: 'forgot',
    loadChildren: () => import('./pages/forgot/forgot.module').then((m) => m.ForgotModule),
    title: 'Forgot password | Ontario Security License'
  },
  {
    path: 'start',
    loadChildren: () => import('./pages/start/start.module').then((m) => m.StartModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then((m) => m.ProfileModule)
  },
  {
    path: 'use-of-force',
    loadChildren: () => import('./pages/use-of-force/use-of-force.module').then((m) => m.UseOfForceModule)
  },
  {
    path: 'learn',
    loadChildren: () => import('./pages/learn/learn.module').then((m) => m.LearnModule)
  },
  {
    path: 'formalities',
    loadChildren: () => import('./pages/formalities/formalities.module').then((m) => m.FormalitiesModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./pages/admin/admin.module').then((m) => m.AdminModule)
  },
  {
    path: 'about-us',
    loadChildren: () => import('./pages/about/about.module').then((m) => m.AboutUsModule),
  },
  {
    path: 'license',
    loadChildren: () => import('./pages/license/license.module').then((m) => m.LicenseModule),
  },
  {
    path: 's',
    loadChildren: () => import('./pages/static/static.module').then((m) => m.StaticModule),
  },
  {
    path: '**',
    redirectTo: 'login'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    preloadingStrategy: PreloadAllModules
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
